import Glide from "@glidejs/glide";
let glide = null;

function initSlider(id) {
    glide = new Glide('#' + id, {
        type: 'slider',
        rewind: false, 
        dragThreshold: false,
        bound: true,
        startAt: 0,
        gap: 20,
        perView: 2,
        breakpoints: {
            900: {
                perView: 1,
                dragThreshold: true,
                gap: 10,
            }
        }
    });
    
    glide.mount();
}

export function moveGlide(whichWay) {
    glide.go(whichWay);
}

window.initSliderCategoryOne = initSlider;
window.initSliderCategoryTwo = initSlider;
